<template>
  <div class="consult_warp">
    <FDBannerImg />
    <div class="consult_container">
      <div class="titleBox">
        <div class="title">Q. {{ data.title }}</div>
        <div class="info">
          {{ data.qsInfo }}
        </div>
      </div>
      <div class="navBar barColor">
        <input
          class="searchInput"
          placeholder="请输入问题的关键词（尽可能简短，不超过5个字，长句及标点可能会影响检索效果）"
          v-model="searchValue"
          @keyup.enter="toSearch"
        />
        <div class="searchBtn" @click="toSearch">Search</div>
        <!-- <div class="browse">
          <span>浏览：</span>
          <a
            @click="reset"
            href="javaScript:;"
            target="_self"
            class="all_question"
            >全部问题</a
          >
        </div> -->
      </div>

      <div class="searchBox">
        <div class="topBox barColor">
          <!-- <div><b>Answered By:</b> {{ data.updateBy }}</div> -->
          <div class="count">
            <svg-icon
              icon-class="calendar"
              style="transform: translateY(-1px)"
            />
            <span v-if="data.createTime">
              {{ data.createTime.slice(0, 10) }}
            </span>
            <svg-icon
              icon-class="eye-open"
              style="font-size: 18px; margin-left: 20px"
            />
            <span>
              {{ data.searchNum }}
            </span>
          </div>
        </div>
        <div id="content">
          {{ data.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post, get } from "@u/request";
import FDBannerImg from "@c//FDBannerImg";
export default {
  name: "",
  components: { FDBannerImg },
  data() {
    return {
      data: {},
      filterList: [],
      searchValue: null,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    reset() {
      this.searchValue = null;
      this.toSearch();
    },
    toSearch() {
      if (this.searchValue) {
        this.$router.push(`/consult?searchValue=${this.searchValue}`);
        location.reload();
      } else {
        this.$router.push(`/consult`);
      }
    },
    async getDetail() {
      const { data } = await get("/lib/question/pc/detail", {
        id: this.id,
      }).catch(() => {});
      this.data = data;
      var content = document.getElementById("content");
      content.innerHTML = data.content;
    },
    async getFilterList() {
      const { data } = await get("lib/common/tok/list").catch(() => {});
      this.filterList = data;
    },
  },
  mounted() {
    this.getDetail();
    this.getFilterList();
  },
};
</script>

<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.consult_warp {
  .barColor {
    background-image: linear-gradient(to bottom, #f5f5f5 0, #ebebeb 100%);
    background-color: #f0f0f0;
  }
  .footer {
    height: 62px;
    max-width: 1170px;
    padding: 5px 0;
    margin: 0 auto;
    border-top: 1px solid #ccc;
    text-align: center;
    font-size: 12px;
    a {
      text-decoration: underline;
      color: #2f6fa7;
    }
  }
  .consult_container {
    max-width: 1170px;
    padding: 0;
    margin: 0 auto;
    h2 {
      font-weight: 700;
      font-size: 16px;
      margin: 20px 0;
    }
    .top {
      padding: 8px 15px;
      font-size: 14px;

      a {
        text-decoration: underline;
        color: #2f6fa7;
      }
    }
    .titleBox {
      padding: 40px 0 20px;
      .title {
        font-size: 36px;
        line-height: 1.1;
      }
      .info {
        font-size: 14px;
        margin-bottom: 20px;
        margin-top: 10px;
      }
    }
    .navBar {
      width: 100%;
      display: flex;
      border: 1px solid #ccc;
      min-height: 52px;
      margin-bottom: 10px;
      border-radius: 4px;
      font-size: 14px;
      .searchInput {
        margin: 8px 0 8px 30px;
        height: 34px;
        width: 550px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        outline: none;
      }
      .searchInput:focus {
        border-color: #409eff;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #969696;
      }
      .searchBtn {
        cursor: pointer;
        height: 34px;
        padding: 6px 12px;
        margin: 8px 30px 8px 20px;
        background-color: #494949;
        color: #fff;
        border-radius: 4px;
      }
      .searchBtn:hover {
        background-color: #555;
      }
      .browse {
        border: 1px solid #ccc;
        border-radius: 4px;
        background-color: #fff;
        margin: 8px 20px;
        margin-left: auto;
        color: #454545;
        font-weight: 700;
        line-height: 34px;
        padding: 0 20px;
        .all_question {
          color: #454545;
          padding: 0 20px;
        }
        .all_question:hover {
          text-decoration: underline;
        }
      }
    }
    .searchBox {
      border: 1px solid #ccc;
      margin: 20px 0 30px;
      .topBox {
        display: flex;
        width: 100%;
        padding: 10px;
        font-size: 14px;
        .count {
          margin-left: auto;
          margin-right: 10px;
        }
      }
      #content {
        padding: 30px 20px;
      }
    }
  }
}
</style>
